/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateFinancialDataViewModel } from "../types/UpdateFinancialDataViewModel.ts";
import { eAccountTypeSchema } from "./eAccountTypeSchema.ts";
import { ePersonFinancialPaymentMethodSchema } from "./ePersonFinancialPaymentMethodSchema.ts";

export const updateFinancialDataViewModelSchema = z.object({
  bankName: z.string().describe("Nome do banco da conta financeira.").nullish(),
  agency: z.string().describe("Número da agência bancária.").nullish(),
  checkingAccount: z.string().describe("Número da conta corrente.").nullish(),
  savingAccount: z.string().describe("Número da conta poupança.").nullish(),
  paymentMethod: z.optional(
    z
      .lazy(() => ePersonFinancialPaymentMethodSchema)
      .describe(
        "1 = Colleger | 2 = Refound | 3 = CheckingAccountPayment | 4 = SavingAccountPayment | 5 = Check | ",
      ),
  ),
  accountType: z.optional(
    z
      .lazy(() => eAccountTypeSchema)
      .describe("1 = PhysicalPerson | 2 = LegalPerson | "),
  ),
}) as unknown as ToZod<UpdateFinancialDataViewModel>;
